const BASE_URL = '/actions/_simple/hours/';
const CENTRE_HOURS_ENDPOINT = 'centre-hours';
const STORE_ENDPOINT = 'store-hours';

window.getCentreHoursData = async function () {
  const url = `${BASE_URL}${CENTRE_HOURS_ENDPOINT}`;
  const response = await fetch(url);
  return await response.json();
};
window.getStoreHoursData = async function (entryId) {
  const url = entryId
    ? `${BASE_URL}${STORE_ENDPOINT}?storeId=${entryId}`
    : `${BASE_URL}${STORE_ENDPOINT}`;
  const response = await fetch(url);
  return await response.json();
};